// =============================================================
// 🎧 useRealtimeStats.js — Estatísticas AO VIVO
// =============================================================
//
// Esse hook escuta TODAS as sessões em tempo real e calcula:
//
// - activeCount          (status = "aceita")
// - pendingCount         (status = "pendente")
// - typingCount          (usuarios digitando)
// - operatorControlled   (atendimentos com operador)
// - aiControlled         (atendimentos só da IA)
//
// Ele será lido por LiveStatsBar e outros widgets.
//
// =============================================================

import { useEffect, useState } from "react";
import { listenAllSessions } from "../../services/iaDashboard/sessionsService";

export default function useRealtimeStats() {
  const [activeCount, setActiveCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [typingCount, setTypingCount] = useState(0);
  const [operatorControlled, setOperatorControlled] = useState(0);
  const [aiControlled, setAiControlled] = useState(0);

  useEffect(() => {
    const unsub = listenAllSessions((sessions) => {
      let act = 0;
      let pend = 0;
      let typing = 0;
      let op = 0;
      let ai = 0;

      sessions.forEach((s) => {
        if (s.status === "aceita") act++;
        if (s.status === "pendente") pend++;

        if (s.isTyping === true) typing++;

        if (s.operadorId) op++;
        else ai++;
      });

      setActiveCount(act);
      setPendingCount(pend);
      setTypingCount(typing);
      setOperatorControlled(op);
      setAiControlled(ai);
    });

    return () => unsub && unsub();
  }, []);

  return {
    activeCount,
    pendingCount,
    typingCount,
    operatorControlled,
    aiControlled,
  };
}
